<template>
    <scenario-list-item-base
            v-bind:scenario="scenario"
            v-bind:class="{ 'active-scenario': scenario.isActive }"
    >
        
        <template v-slot:bottom>       
            <div class="scenario-list-item-content footer-content">
                <div class="row footer-row">
                    <div class="col-12 form-group">
                        <span class="dmv-text dmv-text-secondary scenario-list-item-estimate">
                            {{resource('DmvScenarioIndexModel_MonthlyEstimate_Label')}}: 
                            
                            <span class="scenario-list-item-estimate-number">{{ scenario.monthlyEstimate }}</span>
                        </span>
                    </div>
                    
                    <div class="col-12">
                        <scenario-list-item-checkbox
                                v-if="showCheckBox"
                                
                                v-bind:label="scenario.checkboxText"
                                v-bind:value="scenario.isActive"
                                v-bind:disabled="scenario.isDisabled"
                                v-bind:disabled-click-warning-message="scenario.disabledReason"
                                
                                @input="$emit('scenario-selection-changed', $event)"
                        ></scenario-list-item-checkbox>
                    </div>
                </div>
            </div>
        </template>
    </scenario-list-item-base>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources'

    import dmVisualizerApi from '../../../../Api/dm-visualizer'

    import ScenarioListItemBase from "./../ScenarioListItemBase.vue";
    import ScenarioListItemCheckbox from "./ScenarioListItemCheckbox.vue";

    export default {
        name: "scenario-list-item",
        mixins: [resourceMixin],
        components: { 
            ScenarioListItemCheckbox,
            ScenarioListItemBase
        },
        created(){
            const vm = this;
            
            dmVisualizerApi.validateWritePermission().then(
                canWrite => vm.canWrite = canWrite
            )
        },
        computed: {
            showCheckBox(){
                //An active checkbox can't change state anymore
                return this.canWrite || this.scenario.isActive;
            }
        },
        data: () => ({
            canWrite: false
        }),
        props: {
            scenario: {
                type: Object,
                required: true,
                default: () => ({
                    name: '',
                    imageUrl: null,
                    description: '',
                    checkboxText: '',
                    
                    confirmationTextHeader: '',
                    confirmationText: '',
                    isActive: false,
                    monthlyEstimate: 0,
                    
                    isDisabled: false,
                    disabledReason: ''
                })
            }
        }
    }
</script>

<style scoped src="../../Style/scenario-list-item.scss" lang="scss">
</style>
